import Cookies from 'universal-cookie'

export function getAnonymousId(): string | null {
  const cookies = new Cookies()
  const anonymousId = cookies.get('ajs_anonymous_id', { doNotParse: true })
  return anonymousId
}
